import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { getCustomSenders, updateCustomSender } from '../../services/customSenders';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress } from '@material-ui/core';
import { Button, InputField, Modal, Text } from '@getpingback/realeza';
import { PencilSingleIcon } from '@stash-ui/regular-icons';

const CustomSender = ({ location, match }) => {
  const dispatch = useDispatch();

  const [customSenders, setCustomSenders] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingCustomSender, setEditingCustomSender] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [isLoadingEdit, setIsLoadingEdit] = useState(false);

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayCustomSenders(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const handleUpdateCustomSender = async () => {
    try {
      setIsLoadingEdit(true);
      await updateCustomSender(editingCustomSender.id, { channelUid: editValue });
      dispatch(showAlert('success', 'Custom sender updated successfully'));
      setEditModalOpen(false);
      setEditingCustomSender(null);
      displayCustomSenders();
      setIsLoadingEdit(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      setIsLoadingEdit(false);
    }
  };

  const headers = ['id', 'domain', 'status', 'createdAt', 'deletedAt'];
  const SearchBoxHeaders = ['id', 'domain'];

  const displayCustomSenders = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: customSenders } = await getCustomSenders(currentPage || page, params);

      setCustomSenders(customSenders.rows);
      setTotalItems(customSenders.count);
      setTotalPages(customSenders.pages);
      setPage(customSenders.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="users-container">
        <h1>Custom Senders ({totalItems})</h1>

        <div className="users-right">

          <SearchBox
            date-testid="search-box"
            selectItems={SearchBoxHeaders}
            onSubmitSearch={handleSubmitSearch}
            isSearching={isSearching}
            setIsOrdering={setIsOrdering}
          />
        </div>
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={customSenders}
        action={false}
        bodyColumn={headers}
        linkPath={'custom-senders'}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
        customActions={[
          {
            icon: <PencilSingleIcon />,
            action: item => {
              setEditingCustomSender(item);
              setEditValue(item.channelUid);
              setEditModalOpen(true);
            },
          },
        ]}
      />

      <Modal isOpen={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Text tag="h2" type="subtitle" size={20} weight="semibold">
          Edit custom sender
        </Text>
        <Text color="gray">Update the channelUid of the custom sender.</Text>

        <InputField style={{ marginTop: '16px' }} value={editValue} onChange={e => setEditValue(e.target.value)} placeholder="channelUid" />
        <Button fullWidth appearence="solid" mt="16px" isLoading={isLoadingEdit} onClick={handleUpdateCustomSender}>
          Update
        </Button>
      </Modal>
    </>
  );
};

export default CustomSender;
